import { Plugin } from "..";
import { defaultCommentBarDataOptions } from "./comment-bar-data-options";
import { defaultCommentBarOptions } from "./comment-bar-options";

export const CommentBar: Plugin = {
	id: "comment-bar",
	type: "history",
	header: {
		visible: false,
		edit: false,
		fullscreen: false,
	},
	name: "commentBar",
	component: defineAsyncComponent(() => import("./CommentBarPlugin.vue")),
	config: defineAsyncComponent(() => import("./CommentBarPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./CommentBarDataConfig.vue")),
	defaultDataResolver: () => defaultCommentBarDataOptions,
	defaultOptionsResolver: () => defaultCommentBarOptions,
	dimension: {
		minWidth: 8,
	},

	currentVersion: 1,
	migrations: {},
};
